import { Grid } from "@generalapplications/ui";

import { RelatedArticleCard } from "./BlogPostCard";
import type { BlogPostSummary } from "@/content/blog";

export type ArticleCardGridProps = {
  posts: readonly BlogPostSummary[];
  ariaLabel?: string;
};

// The two-up card grid shared by the blog's "Related Reads" and the
// proof-article section on a service page. The heading and the surrounding
// section belong to the caller — the blog places this after an article, a
// service page inside a PageSection — around identical content.
export function ArticleCardGrid({ posts, ariaLabel }: ArticleCardGridProps) {
  if (posts.length === 0) return null;

  return (
    <Grid as="ul" aria-label={ariaLabel} columns={{ base: 1, sm: 2 }} gap="lg">
      {posts.map((post) => (
        <li key={post.slug}>
          <RelatedArticleCard post={post} />
        </li>
      ))}
    </Grid>
  );
}
